import canUseDOM from './can-use-dom';

var updateDirection = function updateDirection(i18n) {
  if (canUseDOM) document.body.setAttribute('dir', i18n.dir());
};

export default updateDirection;